import type { XModule } from '../x-modules.types'
import type { DeviceXStoreModule } from './store/types'
import { XPlugin } from '../../plugins/x-plugin'
import { deviceEmitters } from './store/emitters'
import { deviceXStoreModule } from './store/module'
import { deviceWiring } from './wiring'

/**
 * Device {@link XModule} alias.
 *
 * @public
 */
export type DeviceXModule = XModule<DeviceXStoreModule>

/**
 * Device {@link XModule} implementation. This module is auto-registered as soon as you
 * import any component from the `device` entry point.
 *
 * @public
 */
export const deviceXModule: DeviceXModule = {
  name: 'device',
  storeModule: deviceXStoreModule,
  storeEmitters: deviceEmitters,
  wiring: deviceWiring,
}

XPlugin.registerXModule(deviceXModule)
